export const getIdFromAnnotation = (annotation) => annotation.cy;
